import './RahbaSlide.css';

export default function RahbaSlide() {
  return (
    <section className="slide-content rahba-slide">
      <div className="template-nav">
        <b>WARDIERE INC.</b>
        <span>Home</span><i /><span>About</span><i /><span>Service</span>
      </div>

      <div className="rahba-composition">
        <div className="question-panel">
          <div className="question-index">05</div>
          <h2>why are we interested in Al Rahba Hospital?</h2>
          <div className="question-rule" />
          <div className="question-mark" aria-hidden="true">?</div>
        </div>

        <div className="question-field question-field--branded">
          <span className="orbit orbit-a" />
          <span className="orbit orbit-b" />
          <span className="orbit orbit-c" />

          <div className="rahba-orbit-logo">
            <span className="rahba-orbit-logo__halo" aria-hidden="true" />
            <img
              src="/assets/al-rahba-logo.png"
              alt="Touch of Health Rehabilitation Center"
            />
          </div>

          <i className="dot dot-a" />
          <i className="dot dot-b" />
          <i className="dot dot-c" />
          <i className="dot dot-d" />
        </div>
      </div>
    </section>
  );
}
